export default __webpack_public_path__ + "static/media/cancel_black.6efb86d9.svg";